import { useFlags } from 'launchdarkly-react-client-sdk';
import { useReactiveFeatureFlagValue } from '@/app/contexts';

/** LaunchDarkly key for the "What TimePilot sees" source inspector. */
export const SOURCE_TEXT_FLAG_KEY = 'view-source-text-representation';
/** The same flag as the React SDK exposes it (camel-cased). */
export const SOURCE_TEXT_FLAG_CAMEL = 'viewSourceTextRepresentation';

/**
 * Whether the source inspector is on. The main app folds LaunchDarkly (and dev
 * overrides) into FeaturesContext; the analytics pages instead sit under their
 * own LDProvider with a minimal FeaturesContext, so both sources are read.
 * Outside any LDProvider `useFlags()` is an empty map, so this is simply off.
 */
export function useSourceTextRepresentationEnabled(): boolean {
  const fromContext = useReactiveFeatureFlagValue(SOURCE_TEXT_FLAG_CAMEL);
  const ldFlags = useFlags() as Record<string, unknown>;
  return (
    fromContext === true || ldFlags[SOURCE_TEXT_FLAG_CAMEL] === true || ldFlags[SOURCE_TEXT_FLAG_KEY] === true
  );
}
